import React, { useState } from "react";
import meetnow from "../../../../styles/images/meetnow.svg";
import joinnow from "../../../../styles/images/joinnow.svg";
import eventsvg from "../../../../styles/images/eventsvg.svg";
import styles from "./meetingDetails.module.scss";
import JoinMeetingPopup from "../popUp/joinMeeting";
import LetsMeetNow from "../popUp/letsMeetNow";
import { storeCurrentMeetingDetail, storeMeetingPage, storePreviousMeetingDetail, storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import store from "../../../../context/store/store";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";

type MeetingTopScreenState = {
  isMeetNow: boolean;
  isJoinMeet: boolean;
  isPersonalId: boolean;
  isAudio: boolean;
  isVideo: boolean;
};
export default function MeetingDetailsTop() {

  const [getData, setData] = useState<MeetingTopScreenState>({
    isMeetNow: false, isJoinMeet: false, isPersonalId: false, isAudio: false, isVideo: true
  });
  let { meetingReducer }: any = useSelector((state: any) => state);
  let { detailPage,currentWindowState,previousMeetingDetailPage } = meetingReducer;
  let history: any = useHistory();
  const meetinNowPopupStatus = (action: boolean) => {
    history.push("/meeting");
    setData({ ...getData, isMeetNow: action });
  };

  const joinMeetingPopstatus = (action: boolean) => {
    history.push("/meeting");
    setData({ ...getData, isJoinMeet: action });
  };
  const scheduleMeetingPopStatus = (action: boolean) => {
    history.push("/meeting");
    storeWindowState("createMeeting");
  };

  const backTodetailPage = () => {
    if(history.location.pathname.includes("meetingDetails")){
      storeWindowState("mainPage");
      history.push("/meeting");
    }
    if(!_.isEmpty(previousMeetingDetailPage)){
      storeCurrentMeetingDetail(previousMeetingDetailPage);
      storeMeetingPage(previousMeetingDetailPage);
      storePreviousMeetingDetail({});
    }
    else{
      storeWindowState("mainPage");
      storeCurrentMeetingDetail({});
      storeMeetingPage({});
    } 
  };

  const backToTemplateList = () => {
    // storeWindowState("mainPage");
    storeWindowState("templateList");
  }

  let windowState :any =['createMeeting','editMeeting','reschedule','templateList','useTemplate'];
  
  return (
    <>
      <div className={ !(windowState.includes(currentWindowState)) ? styles.meetingDetailsTop :`${styles.meetingDetailsTop} ${styles.tapcenteralign}`}>
    { !(windowState.includes(currentWindowState)) &&
      <div className={styles.leftbackbtn}>
          <span className="icon_searchlft" onClick={currentWindowState === "meetingDetails" ? backTodetailPage : backToTemplateList}></span>
          <label  onClick={currentWindowState === "meetingDetails" ? backTodetailPage : backToTemplateList}>{currentWindowState === "templateDetails"
           && currentWindowState === 'meetingDetails' ? "Saved Template" : "Back"}</label>
        </div>
         }
        <div>
          <ul>{!(windowState.includes(currentWindowState)) &&
          <>
            <li className={styles.whiteBtnbdr} onClick={() => meetinNowPopupStatus(true)}>
              <img src={meetnow} alt="" /> Meet Now</li>
            <li className={styles.whiteBtnbdr} onClick={() => joinMeetingPopstatus(true)}>
              <img src={joinnow} alt="" /> Join Now</li>
             <li className={styles.whiteBtnbdr} onClick={() => scheduleMeetingPopStatus(true)}>
              <img src={eventsvg} alt="" /> Schedule</li>
              </>}
            {getData.isJoinMeet && <JoinMeetingPopup joinMeetingStatus={joinMeetingPopstatus} />}
            {getData.isMeetNow && <LetsMeetNow leetsMeetNowStatus={meetinNowPopupStatus} meetDetails={getData} />}
          </ul>
        </div>

      </div>
    </>
  );
};

